// extracted by mini-css-extract-plugin
var _1 = "Accordion-modulebox__IQL8g";
var _2 = "Accordion-moduleclear__lRKab";
var _3 = "Accordion-modulecontent__tsh0L";
var _4 = "Accordion-modulecontent1__c5OKx";
var _5 = "Accordion-modulecontent2__okyXx";
var _6 = "Accordion-modulefilters__cBDx0";
var _7 = "Accordion-moduleitem__vBmXD";
var _8 = "Accordion-modulemobile__qvH3X";
var _9 = "Accordion-modulesection__VCNbl";
var _a = "Accordion-moduletag__KCVI1 Tag-moduleTag__FLr9H";
export { _1 as "box", _2 as "clear", _3 as "content", _4 as "content1", _5 as "content2", _6 as "filters", _7 as "item", _8 as "mobile", _9 as "section", _a as "tag" }
